import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp7-you-know-who-claims",
  name: `The Quibbler\n'You-Know-Who Claims Another Victim'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'You-Know-Who Claims Another Victim'",
  },
  origin: `Harry Potter and the Deathly Hallows`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
